module.exports = __webpack_public_path__ + "static/Interstate-LightCondensed.474c6f5d.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Interstate-LightCondensed.otf
// module id = 324
// module chunks = 168707334958949